const TTBH_FAQ = Object.freeze({
  title: {
    key: 'TTBH_FAQ_TITLE',
    disabledKey: 'TTBH_FAQ_TITLE_DISABLED',
    value: 'FAQ',
  },
  bullet: {
    atHome: {
      key: 'TTBH_BULLET_HEAD_TEXT',
      value: 'Tap.Try.Buy. at Home: ',
    },
    onSite: {
      key: 'TTB_ON_SITE_BULLET_HEAD_TEXT',
      value: 'Tap.Try.Buy. at a Pomelo Location: ',
    },
  },
  sections: [
    {
      key: 'overview',
      title: {
        disabledKey: 'TTBH_FAQ_OVERVIEW_TITLE_DISABLED',
        value: 'Overview',
      },
      contentBody: [
        {
          question: {
            disabledKey: 'TTBH_FAQ_OVERVIEW_TYPE_QUESTION_DISABLED',
            value:
              'What is the difference between Tap.Try.Buy. at Home and Tap.Try.Buy. at a Pomelo Location?',
          },
          listBlock: {
            hasOrder: true,
            answerTitle: {
              disabledKey: 'TTBH_FAQ_OVERVIEW_TYPE_ANSWER_TITLE_DISABLED',
              value: 'We offer two options for Tap.Try.Buy.:',
            },
            atHomeAnswerOption: {
              key: 'TTBH_FAQ_OVERVIEW_TYPE_ANSWER_OPTION_1',
              value: 'Try at your home for free.',
            },
            onSiteAnswerOption: {
              key: 'TTBH_FAQ_OVERVIEW_TYPE_ANSWER_OPTION_2',
              value: 'Try at a location of your choice for free.',
            },
          },
        },
        {
          question: {
            disabledKey: 'TTBH_FAQ_OVERVIEW_ITEM_QUESTION_DISABLED',
            value: 'How many items can I try each time?',
          },
          paragraphBlock: {
            disabledKey: 'TTBH_FAQ_OVERVIEW_ITEM_ANSWER_DISABLED_DYNAMIC_NUM',
            value:
              'Try up to %d items from our selection of 300+ brands. You may also try multiple sizes and colors of the same item for the perfect fit. *T&Cs apply.',
            dynamicNumber: true,
          },
        },
        {
          question: {
            disabledKey: 'TTBH_FAQ_OVERVIEW_ORDER_RECEIVE_QUESTION_DISABLED',
            value: 'How long does it take to receive my order?',
          },
          paragraphBlock: {
            disabledKey: 'TTBH_FAQ_OVERVIEW_ORDER_RECEIVE_ANSWER_DISABLED',
            value: '1 - 3 business days.',
          },
        },
      ],
    },
    {
      key: 'payment',
      title: {
        disabledKey: 'TTBH_FAQ_PAYMENT_TITLE_DISABLED',
        value: 'Payment & Check Out',
      },
      contentBody: [
        {
          question: {
            disabledKey: 'TTBH_FAQ_PAYMENT_TRY_PERIOD_QUESTION_DISABLED',
            value: 'How long is the try on period?',
          },
          listBlock: {
            specialMobileSpaceBetween: true,
            atHomeAnswerOption: {
              key: 'TTBH_FAQ_PAYMENT_TRY_PERIOD_ANSWER_OPTION_1',
              value:
                'You have 3 days (72 hours) to try on after the delivery date.',
            },
            onSiteAnswerOption: {
              nonTTBHAllow: true,
              disabledKey:
                'TTBH_FAQ_PAYMENT_TRY_PERIOD_ANSWER_OPTION_2_DISABLED',
              value:
                'You have 4 days to try on after the order has arrived at the location.',
            },
          },
        },
        {
          question: {
            disabledKey: 'TTBH_FAQ_PAYMENT_CHARGE_QUESTION_DISABLED',
            value: 'When and how much will I be charged?',
          },
          listBlock: {
            answerTitle: {
              disabledKey: 'TTBH_FAQ_PATMENT_CHARGE_ANSWER_TITLE_DISABLED',
              value: 'We will only charge you for the items you keep.',
            },
            atHomeAnswerOption: {
              value:
                'A hold will be placed on your card for your order total on the day it is placed. At the end of the try on period or after returns\n(if any) are processed, your card will be charged and the hold is removed.',
            },
            onSiteAnswerOption: {
              value:
                'You can choose to pay later at try on location or in advance with your credit/debit card before pick up.',
            },
          },
        },
      ],
    },
    {
      key: 'return',
      title: {
        disabledKey: 'TTBH_FAQ_RETURN_TITLE_DISABLED',
        value: 'Returns',
      },
      contentBody: [
        {
          question: {
            disabledKey: 'TTBH_FAQ_RETURN_FEE_QUESTION_DISABLED',
            value: 'Is there a return fee?',
          },
          paragraphBlock: {
            disabledKey: 'TTBH_FAQ_RETURN_FEE_ANSWER_DISABLED',
            value:
              'Returns are free for both options at drop off locations (Pomelo stores, Thai Post, and 7-Eleven) with the exception of self shipment. Additional costs may apply depending on the courier used.',
          },
        },
        {
          isLastBlock: true,
          question: {
            disabledKey: 'TTBH_FAQ_RETURN_ITEM_QUESTION_DISABLED',
            value: 'How do I return my items?',
          },
          listBlock: {
            answerTitle: {
              disabledKey: 'TTBH_FAQ_RETURN_ITEM_ANSWER_TITLE_DISABLED',
              value:
                'Please note: We will accept returns for items that meet our return criteria.',
            },
            atHomeAnswerOption: {
              key: 'TTBH_FAQ_RETURN_ITEM_ANSWER_OPTION_1',
              value:
                'During try on period, please contact our Customer Service team via Live Chat, Facebook or LINE to begin your return via GrabExpress pickup. Kindly seal your items in any secure packaging.\nPlease note that there is a 69฿ shipping fee for orders under 990฿.',
            },
            onSiteAnswerOption: {
              key: 'TTBH_FAQ_RETURN_ITEM_ANSWER_OPTION_2',
              value:
                'You can return your order at a drop off location (Pomelo stores, Thai Post, and 7-Eleven) or by self shipment within 30 days of the pick-up completed confirmation status.\nTo begin your return, go to "My Returns" under your Account and select "Create a Return".',
            },
            answerDetail: {
              nonTTBHAllow: true,
              disabledKey: 'TTBH_FAQ_RETURN_ITEM_ANSWER_OPTION_DETAIL_DISABLED',
              value:
                '\nPomelo Live Chat on the Pomelo App\n(Go to "Customer Support" under your Account, select "Live Chat" and "Tap.Try.Buy. at Home")\nFB: @pomelo\nLINE: @pomelo\nMonday - Friday: 9.00 - 21.00\nSaturday - Sunday & Public Holidays: 9.00 - 18.00\n\nIf try on period is over, you can return your order at a drop off location (Pomelo stores, Thai Post, and 7-Eleven) or by self shipment within 30 days of the order completed status. To begin your return, go to "My Returns" under your Account and select "Create a Return".',
            },
          },
        },
      ],
    },
  ],
})

export default TTBH_FAQ
